module.exports = __webpack_public_path__ + "8ae4fd9b919d1aea0c2238e00fdc636f.png";